import { useEffect, useState } from 'react'
import axios from 'axios'
import DataTableShell from '../../../../Components/table/DataTableShell'
import TableToolbar from '../../../../Components/table/TableToolbar'
import TableSearch from '../../../../Components/table/TableSearch'
import { TableEmptyRow, TableIdCell, TableSkeletonRows } from '../../../../Components/table/TableCells'
import useClientTable from '../../../../Components/table/useClientTable'

const TABLE_HEAD = [ "UPC", "SKU1", "SKU2" ]

const ManageInventoryTable = ({ batchId }) => {

    const [flattenedBatchList, setFlattenedBatchList] = useState([])

    useEffect(() => {
        const fetchBatchData = async () => {
            try {
                const [nexResponse, acResponse] = await Promise.all([
                    axios.get(`/api/refund-audits/get/${batchId}`),
                    axios.get(`https://api-central.outdoorequippedservice.com/api/v1/warehouse-refunds/audits/batch-content/${batchId}`)
                ])
    
                if (nexResponse.data.message || acResponse.data.message) {
                    console.log("Cannot get batches")
                } else {
                    const nexData = nexResponse.data.result.batchContent
                    const acData = acResponse.data[0].batchDetails
    
                    const tempBatchList = []

                    nexData.forEach(batch => {
                        const acBatch = acData?.find(item => item._id === batch._id)
                        if (acBatch && acBatch?.manageInventoryData.length > 0) {
                                        const upc = batch?.upc || '....'
                                        const sku1 = acBatch?.manageInventoryData?.[0]?.sku || '....' 
                                        const sku2 = acBatch?.manageInventoryData?.[1]?.sku || '....'

                                        tempBatchList.push({ upc, sku1, sku2 });
                        }
                    })
                    setFlattenedBatchList(tempBatchList)
                }
            } catch (error) {
                console.error('Error:', error)
            }
        }
        fetchBatchData()
    }, [batchId])

    const batchesPerPage = 15
    const {
        searchTerm,
        handleSearch,
        currentPage,
        setCurrentPage,
        pageItems: batchData,
        totalPages,
        totalFiltered,
    } = useClientTable({
        data: flattenedBatchList,
        pageSize: batchesPerPage,
        filterFn: (item, query) =>
            !query ||
            item.upc?.toString().toLowerCase().includes(query) ||
            item.sku1?.toString().toLowerCase().includes(query) ||
            item.sku2?.toString().toLowerCase().includes(query),
    })

    return (
        <DataTableShell
            minWidth="640px"
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalPages={totalPages}
            toolbar={
                <TableToolbar
                    kicker="Refund audit"
                    title="Manage inventory"
                    subtitle={`${totalFiltered} matching inventory items`}
                    actions={
                        <TableSearch
                            id="manage-inventory-search"
                            value={searchTerm}
                            onChange={handleSearch}
                            placeholder="Search UPC or SKU"
                        />
                    }
                />
            }
        >
                    <thead>
                        <tr>
                            {TABLE_HEAD.map((head) => (
                                <th key={head} className={head === 'UPC' ? 'nx-sticky-col' : ''}>
                                    {head}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {flattenedBatchList.length <= 0 ?
                            <TableSkeletonRows columns={TABLE_HEAD.length} rows={15} /> :
                            batchData.length === 0 ?
                            <TableEmptyRow columns={TABLE_HEAD.length} title="No inventory items found" description="Try a different UPC or SKU." /> :
                                (batchData.map((item) => (
                                    <tr key={`${item.upc}-${item.sku1}-${item.sku2}`}>
                                        <td className="nx-sticky-col">
                                            <TableIdCell>{item.upc}</TableIdCell>
                                        </td>
                                        <td>{item.sku1}</td>
                                        <td>{item.sku2}</td>
                                    </tr>
                                )))         
                            }
                    </tbody>
        </DataTableShell>
    )
}

export default ManageInventoryTable
